import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const LoadingIndicator = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap={theme.spacing(2)}
      sx={{
        padding: theme.spacing(2),
      }}
    >
      <CircularProgress
        size={theme.spacing(3)}
        color="primary"
      />
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          fontWeight: theme.typography.fontWeightRegular,
        }}
      >
        {t('hotelContent.nimbuxHotels.loadingMore')}
      </Typography>
    </Box>
  );
};
